var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 21L7.34304 16.657M7.34304 16.657C8.08593 17.3998 8.96786 17.9891 9.93849 18.3912C10.9091 18.7932 11.9494 19.0002 13 19.0002C14.0506 19.0002 15.091 18.7932 16.0616 18.3912C17.0322 17.9891 17.9141 17.3998 18.657 16.657C19.3999 15.9141 19.9892 15.0321 20.3913 14.0615C20.7933 13.0909 21.0002 12.0506 21.0002 11C21.0002 9.94936 20.7933 8.90905 20.3913 7.93842C19.9892 6.96779 19.3999 6.08585 18.657 5.34296C17.1567 3.84263 15.1218 2.99976 13 2.99976C10.8783 2.99976 8.84337 3.84263 7.34304 5.34296C5.84271 6.84329 4.99983 8.87817 4.99983 11C4.99983 13.1217 5.84271 15.1566 7.34304 16.657Z",
    stroke: "#161F64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.de45f01ad1835e9c40f99f9dac3e0dda.svg";
export { ForwardRef as ReactComponent };